import {ActionReducer, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromShifts from '../reducers/shift.reducer';
import {combineReducers} from '@ngrx/store';

export interface ShiftsState {
  shifts: fromShifts.ShiftState;
}

export const reducers: ActionReducerMap<ShiftsState> = {
  shifts: fromShifts.reducer,
};

export const reducer: ActionReducer<ShiftsState> = combineReducers(reducers);

export const getShiftState = createFeatureSelector<ShiftsState>('shiftsFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/store/reducers/index.ts